<div class="caption-bar">
  <div class="caption">Einstellungen</div>
</div>

<lib-settings></lib-settings>
